import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  CalculationRoute,
  CalculationPathName,
} from '@/modules/ta/calculation/calculation.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${CalculationRoute.CALCULATIONS}`,
      name: CalculationPathName.CALCULATIONS,
      component: () =>
        import(/* webpackChunkName: "calculations-page" */ './pages/CalculationsPage.vue'),
    },
    {
      path: `/${CalculationRoute.CALCULATIONS}/new`,
      name: CalculationPathName.CALCULATIONFORM_NEW,
      component: () =>
        import(/* webpackChunkName: "calculation-form-page" */ './pages/CalculationFormPage.vue'),
    },
    {
      path: `/${CalculationRoute.CALCULATIONS}/:id`,
      name: CalculationPathName.CALCULATIONFORM,
      component: () =>
        import(/* webpackChunkName: "calculation-form-page" */ './pages/CalculationFormPage.vue'),
    },
  ],
  Module.CALCULATION
);
